import { render, staticRenderFns } from "./ValidateToken.vue?vue&type=template&id=bd27339e"
import script from "./ValidateToken.vue?vue&type=script&lang=js"
export * from "./ValidateToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports